let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bjAoX")).then(() => parcelRequire('feNzb'));